import { Outlet, createFileRoute, useNavigate, useRouterState } from "@tanstack/react-router";

import { Stack, Tabs } from "@/components/ui";

const TABS = [
  { id: "/agent/status", label: "Status" },
  { id: "/agent/pairing", label: "Pairing" },
  { id: "/agent/calibration", label: "Calibration" },
  { id: "/agent/local-settings", label: "Local settings" },
] as const;

type AgentPath = (typeof TABS)[number]["id"];

export const Route = createFileRoute("/agent")({
  component: AgentLayout,
});

function AgentLayout() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const current = TABS.find((tab) => pathname.startsWith(tab.id))?.id ?? TABS[0].id;

  return (
    <main className="mx-auto max-w-5xl px-6 py-10">
      <Stack gap={6}>
        <h1 className="text-2xl font-semibold tracking-tight">Agent</h1>
        <Tabs
          label="Agent"
          value={current}
          tabs={TABS.map((tab) => ({ id: tab.id, label: tab.label }))}
          onChange={(id) => void navigate({ to: id as AgentPath })}
        />
        <Outlet />
      </Stack>
    </main>
  );
}
